import axios from 'axios';
import {
    USERS_API,
    API_HEADER
} from '../../../constants/API'
import {
    VERIFY_BANK_LOADING,
} from '../types';
import { message } from 'antd';

export default (data) => {
    return async (dispatch, getState) => {
        try {
            const { token } = getState().UserReducer;
            dispatch({
                type: VERIFY_BANK_LOADING,
                loadingVerifyBank: true
            });
            await axios.post(`${USERS_API}/stripe/bank/verify`, data, API_HEADER(token));
            dispatch({
                type: VERIFY_BANK_LOADING,
                loadingVerifyBank: false
            });
            window.location.reload()

        } catch (e) {
            if (e && e.response && e.response.data) {
                message.error(String(e.response.data))
            }
            dispatch({
                type: VERIFY_BANK_LOADING,
                loadingVerifyBank: false
            });
        }
    }
}